import { render, staticRenderFns } from "./QrCode.vue?vue&type=template&id=312fa798&scoped=true"
import script from "./QrCode.vue?vue&type=script&lang=js"
export * from "./QrCode.vue?vue&type=script&lang=js"
import style0 from "./QrCode.vue?vue&type=style&index=0&id=312fa798&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "312fa798",
  null
  
)

export default component.exports